import React, { Component, Fragment } from "react";
import InlineError from '../InlineError';
import {
    Input
} from 'reactstrap';
import { connect } from 'react-redux';
import { login } from '../../Reducers/Login/LoginReducer';
import { properties } from '../../constants/Propertise';
import { ClearLocalStorage } from '../../config/ClearLocalStorage';
import Overlay from "../Overlay";
import ForgetPassword from './ForgetPassword';
import preval from "preval.macro";
import packageJson from "../../../package.json";
import { applicatonCache } from '../../Pages/Common/Cache';
import LoginOtp from "./LoginOtp";
import { history } from "../../history";
import AlertMessages from "../AlertMessages";
import base64 from 'base-64';
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import axios from "axios";
import { Auth } from "../../auth";
import { setBackgroundColorRevise, setHeaderBackgroundColourRevise } from "../../Reducers/ThemeOptions";

class NewLoginPage extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            username: '',
            password: '',
            tandc: false,
            errors: {},
            loginRequest: false,
            isCapsLock: false,
            showForgetPasswordPopup: false,
            token: localStorage.getItem('onevubasicauthtoken'),
            inpageLoadingPending: true,
            inpageLoadingError: false,
            inpageLoadingSucess: false,
            showInPageAlertModel: false,
            message: '',
            userDetails: {},

            captchaCodeGenerated: '',
            captchaCode: ''
        };
        ClearLocalStorage.clearStorage();
        applicatonCache.deleteAllCacheData();
    }

    componentDidMount() {
        // localStorage.clear();
        // loadCaptchaEnginge(5, '#e0f2f1', 'black');
    }

    // Method to validate form Input on login page (Client side)
    validate = data => {
        const errors = {};
        if (!data.username) errors.username = properties.userNameRequired;
        if (!data.password) errors.password = properties.passwordRequired;
        if (data.tandc === false) {
            errors.tandc = properties.tandcRequired;
        }

        if (this.state.napAccess === "true") {
            if (!data.captchaCode) errors.captchaCode = properties.captchaCodeReqText;
            if (data.captchaCode !== '' && validateCaptcha(data.captchaCode, false) === false) {
                errors.captchaCode = properties.captchaCodeValidReqText;
            }
        }
        return errors;
    };

    // Method to handle Change form Input on login page (Client side)
    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
        if (event.target.name === "username" || event.target.name === "password") {
            this.setState({
                napAccess: 'false',
                captchaCode: ''
            })
        }
    }

    postformData = (event) => {
        event.preventDefault();
        const errors = this.validate(this.state);
        this.setState({ errors });
        if (Object.keys(errors).length === 0) {
            this.byPassMfa(this.state)
        }
    }

    byPassMfa = (loginData) => {
        this.setState({
            loginRequest: true,
            inpageLoadingPending: true
        })
        let loginUrl = `${process.env.REACT_APP_USERMANAGEMENT_API_URL}checkAccessType`;
        // let loginUrl = `${process.env.REACT_APP_API_URL}checkAccessType`;
        axios.post(loginUrl, {
            "username": loginData.username
        })
            .then(result => {
                if (result.status === 200) {
                    if (result.data.MFA === "True") {
                        // if (result.data.MFA === "True" && result.data.accessType === "") {
                        this.setState({
                            napAccess: 'true'
                        })
                        const errors = this.validate(this.state);
                        this.setState({ errors });

                        if (Object.keys(errors).length === 0) {
                            this.credentialsValidation(this.state)
                        }
                    }
                    // else if (result.data.MFA === "False" && result.data.accessType === "by.pass.mfa") {
                    //     this.handleByPassMfa(this.state)
                    // }
                    else {
                        this.setState({
                            napAccess: 'false'
                        }, () => this.handleByPassMfa(this.state)
                        )
                    }
                } else {
                    this.setState({
                        username: '',
                        password: '',
                        showInPageAlertModel: true,
                        inpageLoadingPending: false,
                        inpageLoadingError: true,
                        inpageLoadingSucess: false,
                        message: properties.globalErrorMessage
                    })
                }
            })
            .catch(error => {
                this.setState({
                    username: '',
                    password: '',
                    captchaCode: '',
                    showInPageAlertModel: true,
                    inpageLoadingPending: false,
                    inpageLoadingError: true,
                    inpageLoadingSucess: false,
                    message: properties.globalErrorMessage
                })
            })
    }

    handleByPassMfa = async (loginData) => {
        this.setState({
            // byPassloginRequest: true,
            loginRequest: true,
            byPassinpageLoadingPending: true,
            byPassinpageLoadingError: false,
            byPassinpageLoadingSucess: false,
        })
        try {
            let loginUrl = process.env.REACT_APP_USERMANAGEMENT_API_URL + "unifiedlogin";
            const loginObj = {
                username: loginData.username.toLowerCase(),
                password: loginData.password
            }
            const headers = {
                'Authorization': "Basic " + base64.encode(loginObj['username'] + ":" + loginObj['password']),
                'Content-Type': 'application/json',
            };
            const config = {
                headers: headers
            };
            const { data, status } = await axios.get(loginUrl, config);

            if (status === 200) {
                console.log("basicAuthToken", data['basicAuthToken'])
                localStorage.setItem('onevubasicauthtoken', data['basicAuthToken']);
                localStorage.setItem('refreshToken', data['bearerToken']);
                localStorage.setItem('onevuusername', data['username']);
                localStorage.setItem('selectedLang', 'En');
                localStorage.setItem('defaultLang', 'En');
                localStorage.setItem('selectedProject', 1);
                localStorage.setItem('oneviewprojects', JSON.stringify(data['unifiedproject']));
                localStorage.setItem('roles', JSON.stringify(data['roles']));

                Auth.authenticateUser(
                    data['username'],
                    loginUrl,
                    data['basicAuthToken']
                );
                Auth.updateUserInformation(data);

                if (data['userPreferences'] !== null) {
                    let { id, sidebarTheme, headerTheme } = data['userPreferences'];
                    localStorage.setItem('id', id);
                    localStorage.setItem('oneviewheaderTheme', headerTheme);
                    localStorage.setItem('oneviewsiderbarTheme', sidebarTheme);

                    this.props.setHeaderBackgroundColourRevise(headerTheme)
                    this.props.setBackgroundColorRevise(sidebarTheme);
                } else {
                    localStorage.setItem('id', null);
                    localStorage.setItem('oneviewheaderTheme', 'bg-info header-text-light');
                    localStorage.setItem('oneviewsiderbarTheme', 'bg-night-sky sidebar-text-light');

                    // this.props.setHeaderBackgroundColourRevise('bg-night-sky header-text-light')
                    // this.props.setBackgroundColorRevise('bg-royal sidebar-text-light');
                }

                this.setState({
                    loginRequest: false,
                    byPassshowInPageAlertModel: true,
                    byPassinpageLoadingPending: false,
                    byPassinpageLoadingError: false,
                    byPassinpageLoadingSucess: true,
                })
            }
        }
        catch (error) {
            console.log(error)
            this.setState({
                loginRequest: false,
                byPassshowInPageAlertModel: true,
                byPassinpageLoadingPending: false,
                byPassinpageLoadingError: true,
                byPassinpageLoadingSucess: false,
                message: "Invalid Credentials"
            })
        }
        // const loginObj = {
        //     username: loginData.username.toLowerCase(),
        //     password: loginData.password
        // }
        // let headers = new Headers();
        // headers.append("Authorization", "Basic " + base64.encode(loginObj['username'] + ":" + loginObj['password']));
        // let requestOptions = {
        //     method: 'GET',
        //     headers: headers,
        //     redirect: 'follow'
        // }
        // this.setState({
        //     // byPassloginRequest: true,
        //     loginRequest: true,
        //     byPassinpageLoadingPending: true,
        //     byPassinpageLoadingError: false,
        //     byPassinpageLoadingSucess: false,
        // })
        // fetch(loginUrl, requestOptions)
        //     .then(response => {
        //         if (response.status === 200) {
        //             response.text()
        //                 .then(text => {
        //                     try {
        //                         const data = JSON.parse(text);
        //                         localStorage.setItem('onevubasicauthtoken', data['basicAuthToken']);
        //                         localStorage.setItem('refreshToken', data['bearerToken']);
        //                         localStorage.setItem(onevuusername', data['username']);
        //                         localStorage.setItem('selectedLang', 'En');
        //                         localStorage.setItem('defaultLang', 'En');
        //                         localStorage.setItem('selectedProject', 1);
        //                         localStorage.setItem('roles', JSON.stringify(data['roles']));
        //                         localStorage.setItem('oneviewprojects', JSON.stringify(data.unifiedproject));

        //                         Auth.authenticateUser(
        //                             loginObj.username,
        //                             loginUrl,
        //                             data['basicAuthToken']
        //                         );
        //                         Auth.updateUserInformation(data);

        //                         this.setState({
        //                             loginRequest: false,
        //                             byPassshowInPageAlertModel: true,
        //                             byPassinpageLoadingPending: false,
        //                             byPassinpageLoadingError: false,
        //                             byPassinpageLoadingSucess: true,
        //                         })
        //                     } catch (error) {
        //                         console.error("Error parsing JSON response:", error);
        //                     }
        //                 })
        //         } else {
        //             this.setState({
        //                 loginRequest: false,
        //                 byPassshowInPageAlertModel: true,
        //                 byPassinpageLoadingPending: false,
        //                 byPassinpageLoadingError: true,
        //                 byPassinpageLoadingSucess: false,
        //                 message: "Invalid Credentials"
        //             })
        //         }
        //     })
        //     .catch(error => {
        //         this.setState({
        //             loginRequest: false,
        //             byPassshowInPageAlertModel: true,
        //             byPassinpageLoadingPending: false,
        //             byPassinpageLoadingError: true,
        //             byPassinpageLoadingSucess: false,
        //             message: properties.globalErrorMessage
        //         })
        //     });
    }

    credentialsValidation = (loginData) => {
        let loginUrl = process.env.REACT_APP_USERMANAGEMENT_API_URL + "unifiedlogin";

        const loginObj = {
            username: loginData.username.toLowerCase(),
            password: loginData.password
        }
        let headers = new Headers();
        headers.append("Authorization", "Basic " + base64.encode(loginObj['username'] + ":" + loginObj['password']));
        let requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow'
        }
        this.setState({
            loginRequest: true,
            inpageLoadingPending: true,
            inpageLoadingError: false,
            inpageLoadingSucess: false,
        })
        fetch(loginUrl, requestOptions)
            .then((validateResponse) => {
                if (validateResponse.status === 200) {
                    this.setState({
                        showOTPPopup: true,
                        userDetails: {
                            username: loginData.username.toLowerCase(),
                            password: loginData.password
                        },
                        showInPageAlertModel: true,
                        inpageLoadingPending: false,
                        inpageLoadingError: false,
                        inpageLoadingSucess: true,
                        message: "OTP Sent Successfully to Email"
                    })

                    setTimeout(() => {
                        if (this.state.inpageLoadingSucess === true) {
                            this.setState({
                                showInPageAlertModel: false
                            })
                        }
                    }, 2000)
                    loadCaptchaEnginge(5, '#e0f2f1', 'black');

                } else if (validateResponse.status === 401) {
                    this.setState({
                        username: '',
                        password: '',
                        captchaCode: '',
                        showInPageAlertModel: true,
                        inpageLoadingPending: false,
                        inpageLoadingError: true,
                        inpageLoadingSucess: false,
                        message: "Invalid Credentials"
                    })
                    loadCaptchaEnginge(5, '#e0f2f1', 'black');
                } else {
                    this.setState({
                        username: '',
                        password: '',
                        captchaCode: '',
                        showInPageAlertModel: true,
                        inpageLoadingPending: false,
                        inpageLoadingError: true,
                        inpageLoadingSucess: false,
                        message: properties.globalErrorMessage
                    })
                    loadCaptchaEnginge(5, '#e0f2f1', 'black');
                }
            })
            .catch(error => {
                this.setState({
                    username: '',
                    password: '',
                    captchaCode: '',
                    showInPageAlertModel: true,
                    inpageLoadingPending: false,
                    inpageLoadingError: true,
                    inpageLoadingSucess: false,
                    message: properties.globalErrorMessage
                })
                loadCaptchaEnginge(5, '#e0f2f1', 'black');
            })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.inpageLoadingError !== this.state.inpageLoadingError) {
            if (this.state.inpageLoadingError) {
                setTimeout(() => {
                    this.setState({
                        showInPageAlertModel: false
                    })
                }, 1000)
            }
        }

        if (prevState.byPassinpageLoadingError !== this.state.byPassinpageLoadingError) {
            if (this.state.byPassinpageLoadingError) {
                setTimeout(() => {
                    this.setState({
                        byPassshowInPageAlertModel: false
                    })
                }, 1000)
            }
        }

        if (prevState.inpageLoadingSucess !== this.state.inpageLoadingSucess) {
            if (this.state.inpageLoadingSucess) {
                this.setState({
                    username: '',
                    password: '',
                    captchaCode: ''
                })
                loadCaptchaEnginge(5, '#e0f2f1', 'black');
            }
        }

        if (prevState.napAccess !== this.state.napAccess) {
            if (this.state.napAccess === "true") {
                loadCaptchaEnginge(5, '#e0f2f1', 'black');
            }
        }

        if (prevState.byPassinpageLoadingSucess !== this.state.byPassinpageLoadingSucess) {
            if (this.state.byPassinpageLoadingSucess) {
                history.push(`${process.env.PUBLIC_URL}/welcome`)
            }
        }
    }

    capLock = (event) => {
        if (event.getModifierState('CapsLock') === true) {
            this.setState({ isCapsLock: true });
        } else {
            this.setState({ isCapsLock: false });
        }
    }

    openForgetPasswordPopup = () => {
        this.setState({
            showForgetPasswordPopup: true
        });
    }

    closeForgetPasswordPopup = () => {
        this.setState({
            showForgetPasswordPopup: false
        });
    }

    handleCheckbox = (event) => {
        if (event.target.checked === true) {
            this.setState({
                tandc: true
            });
        } else {
            this.setState({
                tandc: false
            });
        }
    }

    closeOTPPopup = () => {
        localStorage.clear();
        this.setState({
            showOTPPopup: false,
        })
    }

    closeInPageAlertModel = () => {
        this.setState({
            showInPageAlertModel: false
        })
    }

    closeInPageByPassAlertModel = () => {
        this.setState({
            byPassshowInPageAlertModel: false
        })
    }

    handleRefresh = (event) => {
        event.preventDefault();
        loadCaptchaEnginge(5, '#e0f2f1', 'black');
    }

    render() {

        const { username, password, errors, captchaCode } = this.state;
        // let bgPath = process.env.PUBLIC_URL + '/images/bg.png';
        let bgPath = process.env.PUBLIC_URL + '/images/loginbg.png';

        return (
            <Fragment>
                <div className="loginContainer" style={{ backgroundImage: `url(${bgPath})` }}>
                    <Overlay
                        title={properties.forgetPassText}
                        openOverlay={this.state.showForgetPasswordPopup}
                        closeOverlay={this.closeForgetPasswordPopup}
                    >
                        <ForgetPassword
                            closeForgetPasswordPopup={this.closeForgetPasswordPopup}
                        />
                    </Overlay>

                    <div className="tata-yr-logo">

                    </div>

                    <div className="container">
                        <div className="InnerLogin">
                            <div className="form-row">
                                <div className="col-md-12 mb-3">
                                    <div className="login-panel">
                                        <div className="row" style={{ textAlign: "center", display: "block" }}>
                                            <span className="logimg">
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/images/logo-login.png`}
                                                    className="login-logo-form1"
                                                    alt=""
                                                />
                                            </span>
                                        </div>

                                        {/* <div className="row">
                                            <span className="col-md-12 app_name_span">{properties.projectName}</span>
                                        </div> */}

                                        <form
                                            // onSubmit={this.postformData.bind(this)}
                                            onSubmit={this.postformData}
                                            noValidate
                                            className="col-md-12 mb-3"
                                        >
                                            <div className="col-md-12 mb-3">
                                                <Input
                                                    type="text"
                                                    name="username"
                                                    id="username"
                                                    value={username}
                                                    placeholder="Username"
                                                    onChange={this.handleChange}
                                                />
                                                {errors.username && <InlineError text={errors.username} />}
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <Input
                                                    type="password"
                                                    name="password"
                                                    id="password"
                                                    placeholder="Password"
                                                    value={password}
                                                    onKeyPress={this.capLock.bind(this)}
                                                    onChange={this.handleChange}
                                                />
                                                {errors.password && <InlineError text={errors.password} />}
                                                {
                                                    this.state.isCapsLock && <InlineError text={properties.capsLockMessageText} />
                                                }
                                            </div>

                                            {
                                                (this.state.napAccess === "true") ? (
                                                    <>
                                                        <div className="col-md-12 row mx-0 justify-content-between mb-3">
                                                            <div className="mx-1 pt-1">
                                                                <LoadCanvasTemplateNoReload />
                                                            </div>

                                                            <span
                                                                className="pe-7s-refresh pe-lg refrehCaptcha px-1 pt-2"
                                                                onClick={(e) => this.handleRefresh(e)}
                                                                title="Refresh Captcha"
                                                            ></span>

                                                            <div className="col-md-6 px-0">
                                                                <Input
                                                                    type="text"
                                                                    name="captchaCode"
                                                                    id="captchaCode"
                                                                    placeholder="Enter Captcha"
                                                                    value={captchaCode}
                                                                    onChange={this.handleChange}
                                                                />
                                                                {errors.captchaCode && <InlineError text={errors.captchaCode} />}
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : null
                                            }


                                            <div className="col-md-12 mb-3">
                                                <span style={{ marginLeft: '20px' }}>
                                                    <Input
                                                        type="checkbox"
                                                        name="tandc"
                                                        id="tandc"
                                                        onChange={this.handleCheckbox.bind(this)}
                                                    />&nbsp;<span className="forgetpassword">{properties.tandcmessage}</span>
                                                    <a
                                                        className="forgetpassword"
                                                        href={`${process.env.PUBLIC_URL}/images/updatedTermsOfUse.pdf`}
                                                        target="_blank"
                                                        style={{ textDecoration: "underline" }}
                                                    >
                                                        {properties.tandcText}
                                                    </a><br />
                                                    {errors.tandc && <InlineError text={errors.tandc} />}
                                                </span>
                                            </div>
                                            {
                                                (this.state.loginRequest) ? (this.state.inpageLoadingPending === true) ?
                                                    <div
                                                        className="loginLoadingMessage"
                                                    >
                                                        {properties.loginPendingMessge}
                                                    </div> :
                                                    <Fragment>
                                                        <div className="col-md-12 mb-3">
                                                            <button
                                                                type="submit"
                                                                color="primary"
                                                                className="mb-2 mr-2 btn btn-primary btn-lg btn-block"
                                                            >
                                                                {properties.loginText}
                                                            </button>
                                                            <h6>
                                                                <a
                                                                    className="forgetpassword"
                                                                    onClick={this.openForgetPasswordPopup}
                                                                >
                                                                    {properties.forgetPasswordText}
                                                                </a>
                                                            </h6>
                                                            {/* {this.props.apiError && <InlineError text={this.props.apiError} />} */}
                                                        </div>
                                                    </Fragment> :
                                                    <Fragment>
                                                        <div className="col-md-12 mb-3">
                                                            <button
                                                                type="submit"
                                                                color="primary"
                                                                className="mb-2 mr-2 btn btn-primary btn-lg btn-block"
                                                            >
                                                                {properties.loginText}
                                                            </button>
                                                            <h6>
                                                                <a
                                                                    className="forgetpassword"
                                                                    onClick={this.openForgetPasswordPopup}
                                                                >
                                                                    {properties.forgetPasswordText}
                                                                </a>
                                                            </h6>
                                                            {/* {this.props.apiError && <InlineError text={this.props.apiError} />} */}
                                                        </div>
                                                    </Fragment>
                                            }

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="langSelection">
                        <Language
                            updateLanguageSelection={this.updateLanguageSelection.bind(this)}
                        />
                    </div> */}

                    <div>
                        <img src={`${process.env.PUBLIC_URL}/images/Tata-Group-Logo-White.png`} alt="" className="img-responsive tata-yr-img-logo" />
                        <img src={`${process.env.PUBLIC_URL}/images/tctslogo.png`} alt="" className="img-responsive login-logo" />
                    </div>

                    <div className="copyright-textData">
                        <p className="login_copyright">{properties.footerText}</p>
                        {/* <p className="secondLineFooter" style={{ color: "#fff" }}> {properties.tataTagLine}  </p>
                        <p className="secondLineFooter" style={{ color: "#fff" }}> {properties.NeoText}  </p>
                        <p className="login_copyright">
                            {properties.appVersionText}: {packageJson.version}, {properties.buildDateText}: {getBuildDateString()}
                        </p> */}
                    </div>

                </div>

                <Overlay
                    title={properties.loginSecondFactorAuthenticationText}
                    openOverlay={this.state.showOTPPopup}
                    closeOverlay={this.closeOTPPopup}
                >
                    <LoginOtp userDetails={this.state.userDetails} />
                </Overlay>

                <Overlay
                    openOverlay={this.state.showInPageAlertModel}
                    closeOverlay={this.closeInPageAlertModel}
                    className="alertData"
                >
                    <AlertMessages
                        isSucess={this.state.inpageLoadingSucess}
                        isPending={this.state.inpageLoadingPending}
                        apiError={this.state.inpageLoadingError}
                        showAlert={this.state.showInPageAlertModel}
                        closeAlert={this.closeInPageAlertModel}
                        message={this.state.message}
                    />
                </Overlay>

                <Overlay
                    openOverlay={this.state.byPassshowInPageAlertModel}
                    closeOverlay={this.closeInPageByPassAlertModel}
                    className="alertData"
                >
                    <AlertMessages
                        isSucess={this.state.byPassinpageLoadingSucess}
                        isPending={this.state.byPassinpageLoadingPending}
                        apiError={this.state.byPassinpageLoadingError}
                        showAlert={this.state.byPassshowInPageAlertModel}
                        closeAlert={this.closeInPageByPassAlertModel}
                        message={this.state.message}
                    />
                </Overlay>

            </Fragment>
        );

    }
}

const mapStateToProps = (state) => {
    return {
        isLoginSuccess: state.loginData.isLoginSuccess,
        isLoginPending: state.loginData.isLoginPending,
        loginError: state.loginData.loginError,
        authDone: state.loginData.authDone,
        userToken: state.loginData.userToken,
        apiError: state.loginData.apiError,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        login: (loginData) => dispatch(login(loginData)),

        setBackgroundColorRevise: (siderbarTheme) => dispatch(setBackgroundColorRevise(siderbarTheme)),
        setHeaderBackgroundColourRevise: (headerTheme) => dispatch(setHeaderBackgroundColourRevise(headerTheme))
    };
}

const getBuildDateString = () => {
    const buildTimestamp = preval`module.exports = new Date();`;

    const formattedDate = Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
    }).format(new Date(buildTimestamp));

    return formattedDate;
};

export default connect(mapStateToProps, mapDispatchToProps)(NewLoginPage);